import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import memoize from 'memoize-one';
import { Button, Form, Grid, Header, Input, Message, Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import { updateUserSettings, changeLanguage } from '../../actions';

import './Settings.scss';

class UserSettings extends Component {
    state = { username: undefined, success: false, error: '', language: i18next.language };

    calculateUsername = memoize((existingUsername, inputtedUsername) => {
        return inputtedUsername === undefined ? existingUsername || '' : inputtedUsername;
    });

    constructor(props) {
        super(props);
    }

    validateUsername = (username) => {
        if (!username) {
            return 'usernameNotProvided';
        }

        if (username.length < 4 || username.length > 25) {
            return 'usernameLength';
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();

        const { user, updateUserSettings } = this.props;
        const { username } = this.state;
        
        this.state.language !== i18next.language && this.props.changeLanguage(this.state.language);

        if (username !== user.username && (user.username || username)) {
            if (this.validateUsername(username)) return;
        
            updateUserSettings({ id: user.id, username: username }, (user) => {
                this.setState({ success: true, error: '' });
            }, (error) => {
                this.setState({ success: false, error: error.response.data });
            });
        }
    }

    render() {
        const { user } = this.props;

        if (!user) return null;

        const languageOptions = i18next.languages.map(lang => ({ text: lang, value: lang, flag: lang === 'he' ? 'il' : 'us' }));

        const currentUsername = this.calculateUsername(user.username, this.state.username);

        return (
            <Grid centered verticalAlign='middle' className='pi-user-settings-grid' >
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column textAlign='center' verticalAlign='middle' style={{ maxWidth: 450 }}>
                        <div className='pi-user-settings-header'>
                            <Header as='h2'>
                                {i18next.t('userSettings.self')}
                            </Header>
                        </div>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                    <Grid.Column style={{ maxWidth: 450 }}>

                        <Form onSubmit={this.handleSubmit}
                            success={this.state.success}
                            error={!!this.state.error}>
                            <Form.Field className='pi-user-settings-username' name='username'>
                                <label className='pi-user-settings-username-label'>
                                    <Icon name='user' color='grey' />{i18next.t('userSettings.username')}
                                </label>
                                <Input placeholder={i18next.t('userSettings.username')} value={currentUsername}
                                    onChange={(event, data) => { this.setState({ username: data.value }); }} />
                            </Form.Field>
                            <Form.Field className='pi-user-settings-email'>
                                <label className='pi-user-settings-email-label'>
                                    <Icon name='at' color='grey' />{i18next.t('userSettings.email')}:&nbsp;
                                </label>
                                <span className='pi-user-settings-email-address'>{user.email}</span>
                            </Form.Field>
                            <Form.Field>
                                <Icon name='lock' color='blue' />
                                <a href='/user/password' target='_blank'>{i18next.t('userSettings.changePassword')}</a>
                            </Form.Field>
                            <Form.Dropdown
                                label={<label><Icon name='language' color='grey' />{i18next.t('userSettings.changeLanguage')}</label>}
                                selection
                                scrolling
                                inline
                                options={languageOptions}
                                value={this.state.language}
                                name='language'
                                onChange={(event, data) => {
                                    this.setState({ language: data.value });
                                }}
                            />
                            <Message success
                                header={i18next.t('userSettings.usernameSuccessTitle')}
                            />
                            <Message error
                                header={i18next.t('userSettings.usernameErrors.failedTitle')}
                                content={i18next.t(`userSettings.usernameErrors.${this.state.error}`)}
                            />
                            <Button type='submit'>{i18next.t('save')}</Button>
                        </Form>

                    </Grid.Column>
                </Grid.Row>

            </Grid>
        );
    }
}

UserSettings.propTypes = {
    token: PropTypes.string,
    updateUserSettings: PropTypes.func,
    changeLanguage: PropTypes.func,
    user: PropTypes.object,
    permissions: PropTypes.object,
    
};

const mapStateToProps = (state) => {
    const { user, permissions } = state.auth;    

    return { user, permissions };
};

export default connect(mapStateToProps, { updateUserSettings, changeLanguage })(UserSettings);
